export const toggleConsentBox = ():void => {
    window['Optanon']?.ToggleInfoDisplay?.()
}